import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/_services/global.service';
interface Iuploaded_data {
  num_enrolled_students: number;
  num_not_enrolled_students: number;
}
@Component({
  selector: 'app-upload-progress-state',
  templateUrl: './upload-progress-state.component.html',
  styleUrls: ['./upload-progress-state.component.scss']
})


export class UploadProgressStateComponent {
  @Input() lang: 'ar' | 'en' = 'en';
  @Input() upload_state: 'uploading' | 'finished' | 'finshed-with-errors' | 'errors-fixed' | 'finshed-with-details' | 'enroll-in-progress' = 'uploading';
  @Input() uploaded_data: Iuploaded_data = { num_enrolled_students: 0, num_not_enrolled_students: 0 };
  @Output() showDetailsEvent = new EventEmitter<void>();
  constructor(private router: Router,
    private globalService: GlobalService) {
  }

  goToFixErrors(e) {
    e.stopPropagation()
    this.globalService.setBulkEnrollNotificationState('not-uploading');
    this.router.navigateByUrl('/buses/bulk-enroll/fix-errors');
  }

  goBack(e) {
    e.stopPropagation();
    this.globalService.setBulkEnrollNotificationState('not-uploading');
    this.router.navigateByUrl('/buses/students');
  }

  goToAssignTrips(e) {
    e.stopPropagation();
    this.globalService.setBulkEnrollNotificationState('not-uploading');
    this.globalService.setBusEnrollNotificationState('');
    this.router.navigateByUrl('/buses/bulk-enroll/assign-trips');
  }

  goToFixErrorsProcessingEnroll(e) {
    e.stopPropagation()
    this.globalService.setAutoBusEnroll(true);
    this.globalService.setNotifyViewWithBulkEnrollState('enroll-in-progress');
    // this.globalService.setBulkEnrollNotificationState('not-uploading');
    this.router.navigateByUrl('/buses/bulk-enroll/fix-errors');
  }

  emitShowDetailsEvent() {
    this.showDetailsEvent.emit();
  }
}


